export default "__VITE_ASSET____UanYZ4__"